import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

export interface LandingPageHeroChicletCtaTextProps {
  readonly label: MessageKey;
}

const LandingPageHeroChicletCtaText = ({
  label,
}: LandingPageHeroChicletCtaTextProps) => {
  const t = useTranslations();

  return (
    <TypographyV3
      className="leading-none"
      color="light"
      Element="span"
      variant="body-small"
      weight="bold"
    >
      {t(label)}
    </TypographyV3>
  );
};

export default LandingPageHeroChicletCtaText;
